<script lang="ts">
  import { getFormatDate } from '../../helpers/date-helper';
  import type { GlobalProperties } from 'customer-components/lib/types';

  export let text =
    'Great people to work with, job was done quickly and efficently. Finished work exceeded expectations. Great people to work with, job was done quickly and efficently. Finished work exceeded expectations. Great people to work with, job was done quickly and efficently. Finished work exceeded expectations.';
  export let by = 'Connor M.';
  export let date = 'Dec 12th, 2022';
  export let stars = 4;
  export let background = '';
  export let settings: GlobalProperties;
</script>

<div class="testimonial-card" style="background: {background}">
  <div class="card-quote">
    <svg
      width="34"
      height="28"
      viewBox="0 0 34 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.15157 4.4865C5.4899 1.9515 9.02823 0.666504 13.6666 0.666504H15.3332V5.36484L13.9932 5.63317C11.7099 6.08984 10.1216 6.98817 9.27157 8.3065C8.7499 9.11817 8.57823 9.98484 8.54157 10.6665H11.9999H13.6666C14.5882 10.6665 15.3332 11.4115 15.3332 12.3332V23.9998C15.3332 25.8382 13.8382 27.3332 11.9999 27.3332H1.9999C1.07823 27.3332 0.333234 26.5882 0.333234 25.6665V17.3332L0.338234 12.4682C0.323234 12.2832 0.00656694 7.89984 3.15157 4.4865ZM30.3332 27.3332H20.3332C19.4116 27.3332 18.6666 26.5882 18.6666 25.6665V17.3332L18.6716 12.4682C18.6566 12.2832 18.3399 7.89984 21.4849 4.4865C23.8232 1.9515 27.3616 0.666504 31.9999 0.666504H33.6666V5.36484L32.3266 5.63317C30.0432 6.08984 28.4549 6.98817 27.6049 8.3065C27.0832 9.11817 26.9116 9.98484 26.8749 10.6665H30.3332H31.9999C32.9216 10.6665 33.6666 11.4115 33.6666 12.3332V23.9998C33.6666 25.8382 32.1716 27.3332 30.3332 27.3332Z"
        fill={settings?.background}
      />
    </svg>

    <p class="author">{@html by}</p>

    <p class="card-text">{@html text}</p>
  </div>

  <p class="date">{getFormatDate(date)}</p>

  <div class="stars">
    {#each Array(stars) as _}
      <img
        class="star"
        src="https://voolt-template-asset.s3.amazonaws.com/template-4/images/star.svg"
        loading="lazy"
        alt=""
      />
    {/each}
  </div>
</div>

<style>
  .testimonial-card {
    background-color: #ffffff;
    width: auto;
    height: auto;
    display: flex;
    max-width: 1200px;
    flex-direction: column;
    grid-row-gap: 40px;
    padding: 32px;
    color: #07090d;
    text-align: center;
    text-decoration: none;
  }
  .date {
    margin-top: 0;
    padding-top: 0;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    text-align: center;
    color: #919197;
    word-break: break-word;
  }
  .card-text {
    font-size: 16px;
    margin-bottom: 0;
    line-height: 28px;
    word-break: break-word;
    font-style: italic;
  }
  .star:not(:first-child) {
    margin-left: 5px;
  }
  .author {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    margin-top: 46px;
    word-break: break-word;
    margin-bottom: 0;
  }
</style>
